//资产
let assetManagement = () => import('@/components/agentAccount/assetManagement/index')

//智能记账
let intellectAccount = () => import('@/components/agentAccount/intellectAccount/index')

// 固定资产
let fixedAssets = () => import('@/components/agentAccount/assetManagement/fixedAssets/fixedAssets')
// 固定资产清理模板
let fixedAssetsClear = () => import('@/components/agentAccount/assetManagement/fixedAssetsClear/fixedAssetsClear')

// 无形资产
let invisibleAssets = () => import('@/components/agentAccount/assetManagement/invisibleAssets/invisibleAssets')
// 无形资产清理模板
let invisibleAssetsClear = () => import('@/components/agentAccount/assetManagement/invisibleAssetsClear/invisibleAssetsClear')

// 固定资产
let salaryModel = () => import('@/components/agentAccount/assetManagement/salaryModel/salaryModel')

export default [{
    path: '/intellectAccount',
    name: 'intellectAccount',
    component: intellectAccount,
    meta: {
      text: '智能记账'
    }
  },
  {
    path: '/assetManagement',
    component: assetManagement,
    children: [{
        path: '/fixedAssets',
        component: fixedAssets,
        name: 'fixedAssets',
        meta: {
          text: '固定资产',
        },
      },
      {
        path: '/invisibleAssets',
        component: invisibleAssets,
        name: 'invisibleAssets',
        meta: {
          text: '无形资产',
        },
      }, {
        path: '/fixedAssetsClear',
        component: fixedAssetsClear,
        name: 'fixedAssetsClear',
        meta: {
          text: '固定资产清理模板',
        },
      },
      , {
        path: '/invisibleAssetsClear',
        component: invisibleAssetsClear,
        name: 'invisibleAssetsClear',
        meta: {
          text: '无形资产清理模板',
        },
      },
      , {
        path: '/salaryModel',
        component: salaryModel,
        name: 'salaryModel',
        meta: {
          text: '工资模板',
        },
      }
    ]
  }
]
